import React from "react";
import styled from "@emotion/styled";
import { H3 } from "../../../../../layouts/TextStyles";
import { DialogContent } from "@mui/material";
import CustomInput from "../../../../../components/muiComponents/customInput";
import { Box } from "@mui/system";
import FlagKz from "../../../../../assets/img/flag-kz.png";
import FlagRu from "../../../../../assets/img/flag-ru.png";
import { Lorum } from "../../../../../utils/constants";

const AddTopicDialogContent = ({ formik }) => {
    return (
        <DialogContent>
            <form>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: 8,
                    }}
                >
                    <Box
                        display={"flex"}
                        flexDirection="column"
                        minWidth={500}
                    >
                        <Box sx={{ height: "160px" }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <H3>Тақырып аты</H3>

                                <img
                                    alt="flag"
                                    src={FlagKz}
                                    style={{
                                        width: 24,
                                        height: 24,
                                        marginLeft: 10,
                                        marginTop: 6,
                                    }}
                                />
                            </Box>

                            <CustomInput
                                id="titleKz"
                                name="titleKz"
                                placeholder="Enter name"
                                fullWidth
                                value={formik.values.titleKz}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                helperText={formik.errors.titleKz}
                                error={Boolean(formik.errors.titleKz)}
                            />
                        </Box>

                        <Box>
                            <H3>Тақырып сипаттамасы</H3>

                            <CustomInput
                                id="descriptionKz"
                                name="descriptionKz"
                                placeholder={Lorum}
                                fullWidth
                                multiline
                                maxRows={10}
                                minRows={10}
                                value={formik.values.descriptionKz}
                                onChange={formik.handleChange}
                                error={Boolean(formik.errors.descriptionKz)}
                                helperText={formik.errors.descriptionKz}
                            />
                        </Box>
                    </Box>

                    <Box
                        display={"flex"}
                        flexDirection="column"
                        minWidth={500}
                    >
                        <Box sx={{ height: "160px" }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <H3>Название темы</H3>

                                <img
                                    alt="flag"
                                    src={FlagRu}
                                    style={{
                                        width: 24,
                                        height: 24,
                                        marginLeft: 10,
                                        marginTop: 6,
                                    }}
                                />
                            </Box>

                            <CustomInput
                                id="titleRu"
                                name="titleRu"
                                placeholder="Enter name"
                                value={formik.values.titleRu}
                                onChange={formik.handleChange}
                                fullWidth
                                helperText={formik.errors.titleRu}
                                error={Boolean(formik.errors.titleRu)}
                            />
                        </Box>

                        <Box>
                            <H3>Описание темы</H3>

                            <CustomInput
                                id="descriptionRu"
                                name="descriptionRu"
                                placeholder={Lorum}
                                fullWidth
                                multiline
                                maxRows={10}
                                minRows={10}
                                value={formik.values.descriptionRu}
                                onChange={formik.handleChange}
                                error={Boolean(formik.errors.descriptionRu)}
                                helperText={formik.errors.descriptionRu}
                            />
                        </Box>
                    </Box>
                </Box>

            </form>
        </DialogContent>
    );
};

export default AddTopicDialogContent;